<ng-container *ngIf="bannerComponent$ | async as bannerComponent">
    <ng-container *msComponentProxy="bannerComponent" />
</ng-container>
